import {
  ACCOUNT,
  MANAGER,
  getOrderTypeName
} from '../../data/gameDay-data.calculation';
import { orderIsRetailType } from '../../data/gameDay-data-orders.calculation';
import { AccountManager, GameDayViewType } from '../../../state/data/state';
import { getLinkType } from '../../mappers/gameDay-orders.transfomations';
import { FilteredTranchesWithFilters } from '../../../state/types';
import { GameDayModel } from '../../../models/gameday-model';

export interface EntityOrder {
  id: number;
  orderNumber: number;
  entity: string;
  series: string;
  maturity: string;
  type: string;
  priority: string;
  amount: number;
  linkType: string;
  accountPriority?: GameDayModel.AccountPriority;
}

export interface EntityDetailsCardInfo {
  amount: number;
  count: number;
  entity: string;
  name: string;
}

export function getEntityOrders({
  tranches: {
    filtered: { deal, orders }
  },
  filters: { searchByAccountManager, viewType }
}: FilteredTranchesWithFilters): EntityOrder[] {
  const series: Record<string, string> = deal.series.reduce(
    (accumulator, { id, code }: GameDayModel.Series) => ({
      ...accumulator,
      [id]: code
    }),
    {}
  );
  const maturities: Record<string, string> = deal.maturities.reduce(
    (accumulator, { id, maturityDate }: GameDayModel.Maturity) => ({
      ...accumulator,
      [id]: maturityDate.toDate()
    }),
    {}
  );
  let filteredOrders: GameDayModel.Order[] = [];

  if (!searchByAccountManager || !orders) {
    return [];
  }

  if (searchByAccountManager.type === MANAGER) {
    filteredOrders = orders.filter(({ syndicateDepartment: { id } }) => {
      return searchByAccountManager.id === id;
    });
  } else if (searchByAccountManager.type === ACCOUNT) {
    filteredOrders = orders.filter(
      ({ accountInfo: { name } }) => searchByAccountManager.name === name
    );
  }

  if (viewType === GameDayViewType.RetailType) {
    filteredOrders = filteredOrders.filter(orderIsRetailType);
  }

  return filteredOrders.map((order: GameDayModel.Order) => {
    return {
      id: undefined,
      orderNumber: order.orderNumber,
      entity:
        searchByAccountManager.type === MANAGER
          ? order.accountInfo.name
          : order.syndicateDepartment.name,
      linkType: getLinkType(order.accountInfo.priority),
      series: series[order.seriesId],
      maturity: maturities[order.maturityId],
      priority: order.orderType.code,
      amount: Math.round(order.amount / 1000),
      comments: order.comments,
      type: getOrderTypeName(order),
      accountPriority: order.accountInfo.priority
    };
  });
}

export function getEntityOrderCardInfo(
  orders: EntityOrder[],
  entity: AccountManager
): EntityDetailsCardInfo | undefined {
  if (!entity) {
    return undefined;
  }

  const ordersAmount = orders.reduce(
    (prev, next) => (next && next.amount ? (prev += next.amount) : prev),
    0
  );

  return {
    count: orders.length,
    name: entity.name,
    entity: entity.type,
    amount: ordersAmount
  };
}
